import '../index.scss';
import { Logo } from '@/components/logo';
import { RenderedLegalDocument } from '@/components/pages/RenderedLegalDocument';

// TCX-668: renders the currently published Franchisor Terms of Use from the
// legal-documents admin system (previously hard-coded static content).
export const TermsOfUseFranchisor = () => (
  <div className="terms-of-use">
    <Logo />
    <RenderedLegalDocument documentType="terms" audience="franchisor" />
  </div>
);

export default TermsOfUseFranchisor;
